import AccountStatementType from './AccountStatementType'

export class StatementInfo {
    RequestID: number;
    EmailAddressToReceiveStatement?: string;
    EmailAddressToReceiveStatement2?: string;
    OverallAccountPhoneNumber?: string;
    SendStatement?: boolean;
    SendInvoice?: boolean;
    InvoiceNumbers?: string;
    AccountStatementTypeID?: number;
    AccountStatementType?: AccountStatementType;
    EmailCopiesTo?: string;
}

export default StatementInfo;